import { min, multiply } from "lodash";
import FormulaLayoutUI from "./FormulaLayoutUI";
import { changeUnit, getMinValue } from "../../Regex";

const TotalFreight = ({
  dispatchWeight,
  finalNetWeight,
  millerBillWeight,
  freightRate,
  unit,
  module=''
}) => {
  const minWeight =  Number(millerBillWeight ?? 0).toFixed(3)
  const arrialMinWeight = getMinValue(Number(finalNetWeight ?? 0), Number(millerBillWeight ?? 0));
  const convertedWeight = changeUnit("MT", unit, Number(minWeight ?? 0));
  const rate = Number(freightRate ?? 0);
  const totalFreight = multiply(Number(module == 'arrival' ? arrialMinWeight : minWeight ?? 0), rate).toFixed(2);

  return (
  <FormulaLayoutUI>

    <div style={{ marginBottom: "12px" }}>
      <strong style={{ fontSize: "15px" }}>Total Freight Formula</strong>
    </div>

    <div
      style={{
        padding: "10px 12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        fontSize: "13px",
        marginBottom: "10px",
      }}
    >

      {module === "arrival" ? (
        <>
          <div>
            Total Freight = Freight Rate × min(Final Net Weight, Miller Bill Weight)
          </div>

          <div style={{ marginTop: "6px", color: "#555" }}>
            = {rate} × min(
            {Number(finalNetWeight).toFixed(3)}, 
            {Number(millerBillWeight).toFixed(3)})
          </div>

          <div style={{ marginTop: "6px" }}>
            = {rate} × {Number(arrialMinWeight).toFixed(3)}
          </div>
        </>
      ) : (
        <>
          <div>
            Total Freight = Freight Rate × Miller Bill Weight
          </div>

          <div style={{ marginTop: "6px", color: "#555" }}>
            = {rate} × {Number(millerBillWeight).toFixed(3)}
          </div>
        </>
      )}

      <div
        style={{
          marginTop: "10px",
          fontSize: "15px",
          fontWeight: 600,
        }}
      >
        Total Freight: ₹ {totalFreight} /-
      </div>

    </div>

  </FormulaLayoutUI>
);
};

export default TotalFreight;
